import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '../styles/globals.css';

/**
 * Application entry point
 * 
 * This file initializes the React application and mounts it to the DOM.
 * React.StrictMode is enabled for development checks.
 */

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
